<template>
  <div
    id="wvMonthlyInsights"
    :class="`body-container ${loadingProgress > 99 ? 'loading-done' : ''} ${
      lang == 'EN' ? 'font-lato' : 'font-kanit'
    }`"
  >
    <div v-if="modalVideoStatus" class="video-modal">
      <div class="container flex-mid">
        <div class="body">
            <div class="flex-center text-header">
              <div class="mt-6">
                <div v-if="modalVideotext === 'section-1'">
                  Monthly Insights - Section 1
                </div>
                <div v-else-if="modalVideotext === 'section-2'">
                  Monthly Insights - Section 2
                </div>
                <div v-else-if="modalVideotext === 'section-3'">
                  Monthly Insights - Section 3
                </div>
                <div v-else-if="modalVideotext === 'section-4'">
                  Monthly Insights - Section 4
                </div>
                <div v-else-if="modalVideotext === 'section-5'">
                  Monthly Insights - Section 5
                </div>
              </div>
              <div
                class="ml-auto fs-32 cursor-pointer"
                @click.prevent="modalVideoStatus = false"
              >
                <i class="el-icon-close"></i>
              </div>
            </div>
            <div
              style="position: relative; padding-bottom: 65.33575317604357%; height: 0;"
            >
              <iframe
                src="https://www.loom.com/embed/d84c3b3b78ba41b7a6a93993b2ca57cf"
                v-if="modalVideotext === 'section-1' && lang == 'TH' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/e9a3ddd01a9f49d9b2837d4be8f0001e"
                v-else-if="modalVideotext === 'section-2' && lang == 'TH' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/e51d2360d111436bbd3bba64f367df8c"
                v-else-if="modalVideotext === 'section-3' && lang == 'TH' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/17b5034c9e3d4d63b745ca226c456940"
                v-else-if="modalVideotext === 'section-4' && lang == 'TH' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/13e1655a699e4db5baecf17b7e650045"
                v-else-if="modalVideotext === 'section-5' && lang == 'TH' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/2f42c410af0b49458004c960b4aac9e0"
                v-else-if="modalVideotext === 'section-1' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/2a6deb3c4410480aa1e4a9ca36fab408"
                v-else-if="modalVideotext === 'section-2' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/a4b30f76a0fc4ce5888745e45702ffb6"
                v-else-if="modalVideotext === 'section-3' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/4488c72507e140df9db730034616fecd"
                v-else-if="modalVideotext === 'section-4' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/d2a2a12b088b4d5ca6553afd0ff2a32d"
                v-else-if="modalVideotext === 'section-5' && user.boss"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/49632ada33f14ab788d61b9bfdf160b8"
                v-else-if="modalVideotext === 'section-1' && lang == 'TH'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/cf757932fb304101ae97cd688ff128db"
                v-else-if="modalVideotext === 'section-2' && lang == 'TH'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/ecc0498e1bd94099b1df46f44c4af92c"
                v-else-if="modalVideotext === 'section-3' && lang == 'TH'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/14c1d172dd884633aee233471501bbea"
                v-else-if="modalVideotext === 'section-4' && lang == 'TH'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/0834854d194b45e5a37913a45cab312e"
                v-else-if="modalVideotext === 'section-1'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/e1c19ee68d36489c90ee6933c2313226"
                v-else-if="modalVideotext === 'section-2'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/0437d18c2ee94c2394256cc0d2ceff9b"
                v-else-if="modalVideotext === 'section-3'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/c76c5700d9404840a019377eeed4145b"
                v-else-if="modalVideotext === 'section-4'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
              <iframe
                src="https://www.loom.com/embed/d2a2a12b088b4d5ca6553afd0ff2a32d"
                v-else-if="modalVideotext === 'section-5'"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
            </div>
        </div>
      </div>
    </div>
    <div class="m-auto p-16">
      <div
        :class="`flex-mid loading-container ${userDetected ? 'none' : ''}`"
        v-if="loadingProgress < 100"
      >
        <div class="">
          <div class="flex-mid">
            <img
              style="width: 300px"
              src="../assets/images/wv-monthly-insights/logo_happily.webp"
              alt=""
              class="mx-auto"
            />
          </div>
          <div class="flex-mid fs-24 fw-700 mb-12" style="margin-top: 62px">
            {{ $t("weMonthlyInsights.yourMonthlyInsights") }}
            <!-- <span class="loading loading-1">.</span>
            <span class="loading loading-2">.</span>
            <span class="loading loading-3">.</span> -->
          </div>
          <div class="center loading-progress-custom">
            <el-progress
              :percentage="loadingProgress"
              :stroke-width="12"
              color="#4A32C6"
              :show-text="false"
            ></el-progress>
          </div>
          <div class="fs-16 fc-000000 center mt-16" style="opacity: 0.72">
            <span v-if="loadingProgress == 0">Loading...</span>
            <span v-else-if="loadingProgress < 21">Take a deep breath...</span>
            <span v-else-if="loadingProgress < 41"
              >Analyzing your contributions...</span
            >
            <span v-else-if="loadingProgress < 61">Take a deep breath...</span>
            <span v-else-if="loadingProgress < 81"
              >Making sense of things...</span
            >
            <span v-else>Almost there...</span>
          </div>
        </div>
      </div>
      <div v-if="loadingProgress > 100">
        <monthly :user="user" @dialogValue="setDialogVideo" />
        <strengths
          v-if="user.boss"
          :user="user"
          @dialogValue="setDialogVideo"
        />
        <engaged :user="user" @dialogValue="setDialogVideo" />
        <connections :user="user" @dialogValue="setDialogVideo" />
        <growing :user="user" @dialogValue="setDialogVideo" />
        <div class="how-to-card">
          <div class="fs-14 fw-700">{{ $t("weMonthlyInsights.howTOUse") }}</div>
          <div class="fs-16 mt-6">
            {{ $t("weMonthlyInsights.thisReportIs") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  components: {
    // loadingEven: require("./even/loading").default,
    monthly: require("./wv-monthly-insights/monthly.vue").default,
    strengths: require("./wv-monthly-insights/strengths.vue").default,
    engaged: require("./wv-monthly-insights/engaged.vue").default,
    connections: require("./wv-monthly-insights/connections.vue").default,
    growing: require("./wv-monthly-insights/growing.vue").default,
  },
  computed: {
    user() {
      return this.$store.getters["monthlyInsignhts/user"];
    },
    loadingProgress: {
      get() {
        return this.$store.getters["monthlyEngaged/loadingProgress"];
      },
      set(value) {
        this.$store.commit("monthlyEngaged/setLoadingProgress", value);
      },
    },
  },
  created() {
    let bytes = CryptoJS.AES.decrypt(
      this.$router.currentRoute.query.uid,
      "HappilyMonthly"
    );
    let originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (originalText) {
      let codeSplit = originalText.split("||");
      let dateSplit = codeSplit[1].split("-");
      const month = dateSplit[1]; // get now
      const year = dateSplit[0]; // get now
      const value = { email: codeSplit[0], month: month, year: year };
      //const value = { email:'wittawat_b@dhas.com', month: month, year: year };
      this.$store.dispatch("monthlyInsignhts/getUser", value);
      this.loadingProgress += 10;
    } else {
      console.warn("Don't have any ID");
      this.$router.push("/");
    }
  },
  data() {
    return {
      themeMode: "light",
      // user: {
      //   id: "", // mock : 969a4e78-d810-11eb-b8bc-0242ac130003
      //   name: "",
      //   firstname: "",
      //   lastname: "",
      //   month: "",
      //   year: "",
      // },
      userDetected: false,
      lang: "EN",
      modalVideoStatus: false,
      modalVideotext: "section-1",
      //
    };
  },
  mounted() {
    const id = this.$router.currentRoute.query.uid;
    const lang = this.$router.currentRoute.query.lang;
    if (lang && lang.toUpperCase() == "TH") {
      localStorage.setItem("lang", "TH");
      this.lang = "TH";
    }if (lang && lang.toUpperCase() == "MS") {
      localStorage.setItem("lang", "MS");
      this.lang = "MS";
    } else {
      localStorage.setItem("lang", "EN");
      this.lang = "EN";
    }
    if (id) {
      // รอให้ getUser set user (มี company) ก่อนค่อย dispatch getTeam — กัน race:
      // setTimeout(4s) เดิมยิงตอน user ยังว่าง (custom-token flow ช้ากว่าเดิม) แล้วอ่าน /company/undefined
      let teamTries = 0;
      const dispatchGetTeam = () => {
        if (this.user && this.user.company) {
          this.$store.dispatch("monthlyEngaged/getTeam", this.user);
        } else if (teamTries++ < 20) {
          setTimeout(dispatchGetTeam, 700);
        }
      };
      dispatchGetTeam();
    } else {
      console.warn("Don't have any ID");
    }
  },
  methods: {
    // async mockAdd() {
    //   for (let i = 0; i < 80; i++) {
    //     await this.$utils("waitingTime", 70);
    //     //this.loadingProgress = i;
    //   }
    // },
    getUserData(id) {
      const paramater = this.$router.currentRoute.query.id;
      const month = this.$router.currentRoute.query.month || "April"; // get now
      const year = this.$router.currentRoute.query.year || "2021"; // get now

      // get data andding to this obj.
      // this.user = {
      //   id: this._user.email,
      //   name: (this._user.firstname+" "+this._user.lastname.slice(0, 1)),
      //   firstname: this._user.firstname,
      //   lastname: this._user.lastname,
      //   image: this._user.profilepic,
      //   month: month,
      //   year: year,
      // }

      //this.userDetected = true;
    },
    setDialogVideo(data) {
      this.modalVideoStatus = data.value;
      this.modalVideotext = data.text;
    },
  },
};
</script>

<style lang="scss" scoped>
// .body-container {
//   // --text-color: #fff;
//   // --bkg-color: #121212; // dark
//   --bkg-color: #efefef;
// }
// // .body-container {
// //   --text-color: #222;
// //   --bkg-color: #fff;
// // }

// @media (prefers-color-scheme: dark) {
//   .body-container {
//     // For dev
//     // --text-color: #222;
//     --bkg-color: #efefef;
//   }
//   // .body-container {
//   //   --text-color: #eee;
//   // --bkg-color: #121212; // dark
//   // }
// }
@keyframes opacity {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0;
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.loading-container {
  min-width: 300px;
  width: calc(100vw - 32px);
  height: calc(100vh - 32px);
  span.loading {
    margin-left: 4px;
    animation-duration: 1.8s;
    animation-iteration-count: infinite;
    animation-name: opacity;
    animation-duration: 2.5s;
  }
  .loading-1 {
    animation-delay: 0.3s;
  }
  .loading-2 {
    animation-delay: 0.6s;
  }
  .loading-3 {
    animation-delay: 0.9s;
  }
}
.body-container {
  transition: 0.3s;
  background: #fcfcfc;
  min-width: calc(800px + 32px);
}
.body-container.loading-done {
  background: #efefef;
}
#wvMonthlyInsights {
  .engaged-container,
  .strengths-container,
  .growing-container,
  .connections-container,
  .insights-container {
    background-color: #fcfcfc;
    padding: 42px;
    border-radius: 24px;
    width: calc(800px - 84px);
    margin-left: auto;
    margin-right: auto;
  }
}
.how-to-card {
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
  background-color: rgba($color: #000000, $alpha: 0.06);
  margin-bottom: 60px;
  width: calc(800px - 32px);
}
.loading-progress-custom {
  width: 300px;
  background-color: rgba($color: #000000, $alpha: 0.15);
  border-radius: 100px;
}
</style>